import axios from "axios";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";

/** A slot API error; `code` is "unavailable" when the slot was taken or is no longer offered (409). */
export interface SlotApiError extends ApiErrorResponse {
  code?: string;
}

export const toSlotError = (error: unknown): SlotApiError => {
  const code = axios.isAxiosError(error) ? error.response?.data?.code : undefined;
  return { ...toApiError(error), code: typeof code === "string" ? code : undefined };
};

/** The 409 a slot request gets when someone else took the slot first. */
export const isSlotTaken = (error: SlotApiError | undefined): boolean =>
  error?.statusCode === 409 || error?.code === "unavailable";
